import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contract-check-skeleton',
  imports: [Skeleton],
  templateUrl: './supplier-contract-check-skeleton.html',
})
export class SupplierContractCheckSkeleton {}
